import React, { useEffect } from "react";

export interface CancelConfirmDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isCancelling?: boolean;
}

export function CancelConfirmDialog({
  isOpen,
  onConfirm,
  onCancel,
  isCancelling,
}: CancelConfirmDialogProps): React.ReactElement | null {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !isCancelling) {
        onCancel();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, isCancelling, onCancel]);

  if (!isOpen) return null;

  return (
    <div
      data-testid="cancel-confirm-dialog"
      onClick={(e) => {
        if (e.target === e.currentTarget && !isCancelling) {
          onCancel();
        }
      }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(41, 42, 49, 0.5)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        zIndex: 999,
      }}
    >
      <div
        style={{
          backgroundColor: "var(--color-paper)",
          borderRadius: "var(--radius-card)",
          boxShadow: "var(--shadow-floating)",
          padding: "24px",
          width: "100%",
          maxWidth: "360px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 700, color: "var(--color-graphite)" }}>
          Отменить подписку?
        </h3>
        <p style={{ margin: 0, fontSize: "14px", color: "var(--color-slate)", lineHeight: 1.4 }}>
          Ваша подписка продолжит действовать до конца оплаченного периода, после чего автопродление
          будет отключено, а доставка новых вакансий приостановлена.
        </p>

        <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
          <button
            type="button"
            onClick={onCancel}
            disabled={isCancelling}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "var(--radius-button)",
              backgroundColor: "var(--color-canvas)",
              color: "var(--color-graphite)",
              border: "none",
              fontWeight: 600,
              fontSize: "14px",
              cursor: isCancelling ? "not-allowed" : "pointer",
            }}
          >
            Назад
          </button>
          <button
            type="button"
            data-testid="confirm-cancel-subscription-btn"
            onClick={onConfirm}
            disabled={isCancelling}
            style={{
              flex: 1,
              padding: "12px",
              borderRadius: "var(--radius-button)",
              backgroundColor: "var(--color-destructive)",
              color: "var(--color-paper)",
              border: "none",
              fontWeight: 600,
              fontSize: "14px",
              cursor: isCancelling ? "not-allowed" : "pointer",
            }}
          >
            {isCancelling ? "Отмена..." : "Отменить"}
          </button>
        </div>
      </div>
    </div>
  );
}
